import React from "react";

export const PLAYER_COLORS = [
  "#D31027", // red
  "#0088CC", // blue
  "#F59E0B", // gold
  "#10B981", // green
  "#8B5CF6", // purple
  "#EC4899", // pink
];

export function Logo({ size = 48, className = "" }) {
  return (
    <img
      src="/icon-512.png"
      alt="Douzième Homme"
      width={size}
      height={size}
      className={`rounded-xl ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export function PlayerBall({ color, name, active = false, size = 40 }) {
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  return (
    <div
      className={`flex items-center justify-center rounded-full font-display font-extrabold text-white transition-transform ${active ? "scale-110" : ""}`}
      style={{
        width: size,
        height: size,
        background: color,
        boxShadow: active ? `0 0 0 3px rgba(255,255,255,0.85), 0 6px 18px -4px ${color}` : `0 4px 10px -2px rgba(0,0,0,0.5)`,
        fontSize: size * 0.42,
      }}
    >
      {initial}
    </div>
  );
}

export function WordMark({ className = "" }) {
  return (
    <div className={`font-display leading-[0.85] ${className}`}>
      <div className="text-white">DOUZIÈME HOMME</div>
      <div className="text-dh-red">LE JEU</div>
    </div>
  );
}
